import React, { useState, useEffect } from "react";
import axios from "axios";
import { AnimatePresence, motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const FloatingWhatsApp = () => {
  const [href, setHref] = useState("");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/settings`)
      .then((r) => setHref(r.data?.whatsapp || ""))
      .catch(() => {});
  }, []);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!href) return null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          href={href}
          target="_blank"
          rel="noreferrer"
          aria-label="Chat with us on WhatsApp"
          data-testid="floating-whatsapp"
          initial={{ opacity: 0, scale: 0.6, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6, y: 20 }}
          transition={{ type: "spring", stiffness: 380, damping: 26 }}
          whileHover={{ scale: 1.06 }}
          whileTap={{ scale: 0.94 }}
          className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-40 grid place-items-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-[0_14px_34px_-8px_rgba(37,211,102,0.7)] focus:outline-none focus:ring-4 focus:ring-[#25D366]/30"
        >
          <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-70 animate-ping" />
          <MessageCircle size={26} className="relative z-10" />
        </motion.a>
      )}
    </AnimatePresence>
  );
};
